import script from "./SummaryStatCards.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryStatCards.vue?vue&type=script&setup=true&lang=js"

import "./SummaryStatCards.vue?vue&type=style&index=0&id=d535b036&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d535b036"]])

export default __exports__